module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/037-jamaica-46bf2fd0e847bab74e6f72bfef6e6fbd.svg";